import { GetterTree } from "vuex";
import { IUserState } from "@/store/modules/user/state";
import { User } from "@/types";

import { IDataProvider, IRootState } from "@/store";

export enum UserGetters {
  GET_ALL = "GET_ALL_USER",
  GET_CURRENT = "GET_CURRENT_USER",
  GET_PROFILE = "GET_PROFILE_USER",
  GET_DATA_PROVIDER = "GET_DATA_PROVIDER_USER",
}

export const getters: GetterTree<IUserState, IRootState> = {
  [UserGetters.GET_ALL](state): User[] | null {
    return state.users;
  },
  [UserGetters.GET_CURRENT](state): User | null {
    return state.user;
  },
  [UserGetters.GET_PROFILE](state): User | null {
    return state.profile;
  },
  [UserGetters.GET_DATA_PROVIDER](state): IDataProvider<User> | null {
    return state.dataProvider;
  },
};
